export default __webpack_public_path__ + "ab0f46617d53f91750935a37113b80d3.svg";